module.exports = __webpack_public_path__ + "static/media/budget.03b5922c.png";